import React from "react";
import "./Hero.css";

export default function Hero() {
  return (
    <div className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title">FIFA World Cup 2026</h1>
        <p className="hero-subtitle">Tournament Simulator</p>
      </div>
    </div>
  );
}
